import { useMutation } from 'react-query';
import axios from '../utils/axios-util';

const postExportData = async (data, url) => {
  const response = await axios({
    url: url,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: data,
  });
  return response.data;
};

const usePostExportData = (url) => {
  return useMutation((data) => postExportData(data, url));
};

export default usePostExportData;
